import { ReactNode } from 'react';

export function AvailableBlocks(props: { children: ReactNode; names?: string[] }) {
  return null;
}
